import { Component, OnInit, ViewChild } from '@angular/core';
import { WorkWorkOrder,
  BigDayBucket,
  BigDayBucketGenSvc,
  Employee} from '../../services_autogenerated/generated_services';
import { WorkOrderFilterPipe } from 'src/app/pipes/work-order-filter.pipe';
import { FilteredWorkWorkOrder } from 'src/app/models/filteredWorkWorkOrder';
import { WorkOrderFilterBarComponent } from '../work-order-filter-bar/work-order-filter-bar.component';
import { FilteredWellnessWorkOrder } from 'src/app/models/filteredWellnessWorkOrder';
import { FilteredQuoteWorkOrder } from 'src/app/models/filteredQuoteWorkOrder';
import { WorkOrderHelperService } from 'src/app/services/work-order-helper.service';

@Component({
    selector: 'app-multiday-jobs-work-panel',
    templateUrl: './multiday-jobs-work-panel.component.html',
    styleUrls: ['./multiday-jobs-work-panel.component.css'],
    providers: [WorkOrderFilterPipe],
    standalone: false
})
export class MultidayJobsWorkPanelComponent implements OnInit {
  selectedView = 'day';
  allBigDayBuckets: BigDayBucket[] = [];
  filteredBigDayBuckets: BigDayBucket[] = [];
  rms: Employee[];
  equipmentTypes: any[];
  isLoading: boolean;
  isNone: boolean = false;

  allWorkOrders: WorkWorkOrder[];
  filteredWorkOrders: FilteredWorkWorkOrder[];
  @ViewChild(WorkOrderFilterBarComponent) filterBarComponent: WorkOrderFilterBarComponent;

  constructor(
    private bigDayBucketService: BigDayBucketGenSvc,
    private workOrderHelper: WorkOrderHelperService
  ) { }

  ngOnInit() {
    this.isLoading = true;
    this.bigDayBucketService.getWithWorkWorkOrders().subscribe(bdb => {
      this.allBigDayBuckets = bdb;
      this.filteredBigDayBuckets = bdb;

      this.allWorkOrders = this.allBigDayBuckets.filter(x => x.workWorkOrder).map(x => x.workWorkOrder);

      this.rms = this.workOrderHelper.getUnique(this.allWorkOrders.map(wo => wo.representative));
      this.equipmentTypes = this.getUniqueNames(this.allWorkOrders.map(wo => { return this.workOrderHelper.getUniqueEquipment(wo).map(e => e.type) }).reduce((acc, curr) => acc.concat(curr), [])
                                       .concat((this.allWorkOrders.map(wo => { return this.workOrderHelper.getUniqueGoBackEquipment(wo).map(e => e.type) }).reduce((acc, curr) => acc.concat(curr), []))));

      this.filteredWorkOrders = this.allWorkOrders;
      this.isLoading = false;
      if(this.filteredBigDayBuckets.length == 0){
        this.isNone = true;
      }
    });    
  }

  updateBigDayBuckets() {
    const workorkOrderIds = this.filteredWorkOrders.map(x => x.id);

    this.filteredBigDayBuckets = this.allBigDayBuckets.filter(bdb => {
      return workorkOrderIds.includes(bdb.workWorkOrderId);
    });
  }

  OnWoFilteringFinished(filteredWorkOrders: (FilteredWellnessWorkOrder | FilteredWorkWorkOrder | FilteredQuoteWorkOrder)[]) {
    this.filteredWorkOrders = filteredWorkOrders as FilteredWorkWorkOrder[];
    this.updateBigDayBuckets();
  }
  private getUniqueNames(arr: any[]) {
    const unique = arr.map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter(e => arr[e]).map(e => arr[e]).sort();

    return unique.map(u => ({fullName: u}));
  }
}
